var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"fa-ul",style:({'--fa-li-margin':_vm.margin})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }